import {
  type RouteObject,
} from "react-router";
import AdminOneUserListApp from "adminone/UserList/app";
import AdminOneUserApp from "adminone/UserDetail/App";

declare let viewModel: any;

export const userForAdminOneRoute: RouteObject = {
  path: "adminone/user",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: AdminOneUserListApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: AdminOneUserApp,
  }]
};